import { render, staticRenderFns } from "./AIChatInput.vue?vue&type=template&id=6fcc5802&scoped=true"
import script from "./AIChatInput.vue?vue&type=script&lang=js"
export * from "./AIChatInput.vue?vue&type=script&lang=js"
import style0 from "./AIChatInput.vue?vue&type=style&index=0&id=6fcc5802&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcc5802",
  null
  
)

export default component.exports